













































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore, { PessoaOperadora, ClassificacaoOperadora } from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ModalRegraDeCalculoIncluirSetorAtendimento extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  get setorAtendimentoList() { return this.getRegrasDeCalculoStore.setorAtendimentoList }

  loadAddRegraCalculoOperadora: boolean = false
  get loadingAddRegraCalculoOperadora() { return this.loadAddRegraCalculoOperadora }
  set loadingAddRegraCalculoOperadora(value: boolean) { this.loadAddRegraCalculoOperadora = value }

  get showModal() { return this.getRegrasDeCalculoStore.modal.setorAtendimento }
  set showModal(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'setorAtendimento', value }) }

  get setorAtendimentoSelected() { return this.getRegrasDeCalculoStore.setorAtendimentoSelected }
  set setorAtendimentoSelected(value: any) { this.getRegrasDeCalculoStore.setSetorAtendimentoSelected(value) }

  searchSetor: string = ''
  loadingSetorAtendimento: boolean = false
  private setorDebounceId: any = null

  @Watch('showModal')
  async onChangeModal(value: boolean) {
    if (value) {
      this.searchSetor = ''
      this.getRegrasDeCalculoStore.setSetorAtendimentoSelected('')
      await this.fetchSetorAtendimento('', 1)
    }
  }

  @Watch('searchSetor')
  onSearchSetorChanged(val: string) {
    clearTimeout(this.setorDebounceId)
    if (!val || val.length < 2) return
    this.setorDebounceId = setTimeout(() => {
      this.fetchSetorAtendimento(val, 1)
    }, 300)
  }

  async fetchSetorAtendimento(termo: string, pagina: number) {
    try {
      this.loadingSetorAtendimento = true
      await this.getRegrasDeCalculoStore.getSetorAtendimentoList({
        page: pagina,
        pageSize: 100,
        term: termo
      })
    } catch (e) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `Falha ao buscar setores de atendimento`,
        icon: 'warning',
        color: '#C62828'
      })
    } finally {
      this.loadingSetorAtendimento = false
    }
  }

  async addRegra() {
    this.loadingAddRegraCalculoOperadora = true
    const request = await this.getRegrasDeCalculoStore.addRegraSetorAtendimento()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828'
      })
      this.loadingAddRegraCalculoOperadora = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Setor incluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32'
    })
    this.loadingAddRegraCalculoOperadora = false
    this.showModal = false
  }
}
